import InlineSpinner_module_default from "./InlineSpinner.module.js";
import classNames from "classnames";
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
import SpinnerIcon from "@vector-im/compound-design-tokens/assets/web/icons/spinner";
//#region src/components/InlineSpinner/InlineSpinner.tsx
var InlineSpinner = forwardRef(function InlineSpinner({ size = 20, className, ...props }, ref) {
	return /* @__PURE__ */ jsx(SpinnerIcon, {
		ref,
		className: classNames(InlineSpinner_module_default.icon, className),
		style: {
			width: size,
			height: size
		},
		...props
	});
});
//#endregion
export { InlineSpinner };

//# sourceMappingURL=InlineSpinner.js.map